module.exports = "<span class=\"completion-indicator glyphicon\" ng-class=\"getIndicatorClass()\" uib-tooltip=\"{{getIndicatorTooltip()}}\"></span>\n";